import React from 'react';
import { soundToPlay } from '../../../mechanics/sounds/sound';
import { sceneSlice } from '../../../store/reducers/SceneReducer';
import { useAppDispatch } from '../../../store/store';
import BaseButton from '../../ui/BaseButton';
import './CampAllies.scss';
import CampAlliesContent from './CampAlliesContent';

const CampAllies = () => {
    const dispatch = useAppDispatch()
    const { setScene } = sceneSlice.actions

    const backClick = () => {
        dispatch(setScene("camp"))
    }

    return (
        <div className='camp-allies component'>
            <div className="camp-allies__wrapper">
                <h1 className="camp-allies__title component-title">Allies</h1>
                <CampAlliesContent />
                <BaseButton name='Back' onClick={backClick} />
            </div>
        </div>
    );
};

export default CampAllies;